import morphism, { StrictSchema } from 'morphism'

import PassengerFormValue from '../../interfaces/client/PassengerFormValue'
import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ClientPassengerFormValueInterface from '../../interfaces/client/PassengerFormValue'

import passengerFormValueToPassenger from '../../schemas/client/passengerFormValueToPassenger'

export default (passenger: PassengerFormValue) =>
  morphism<
    StrictSchema<ClientPassengerInterface, ClientPassengerFormValueInterface>
  >(passengerFormValueToPassenger, passenger)
